import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import {
    Autocomplete,
    Box,
    Breadcrumbs,
    Button,
    Card,
    FormHelperText,
    CircularProgress,
    FormControl,
    FormControlLabel,
    Grid,
    Link,
    Paper,
    TextField,
    Typography,
    Chip,
    IconButton,
} from "@mui/material";
import { Stack } from "@mui/system";
import Switch from "@mui/material/Switch";
import { useForm, useFieldArray } from "react-hook-form";
import * as yup from "yup";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import JoditEditor from "jodit-react"; // ⭐ ADDED: JoditEditor import

import Appbar from "../../components/Appbar";
import Body from "../../layout/Body";
import { useDispatch, useSelector } from "react-redux";
// import { updateVoucherAction } from "../../redux/toolkit/voucher/updateVoucher";
import { getSingleVoucherAction } from "../../redux/toolkit/vouchers/getSingleVoucher";
import { updateVoucherAction } from "../../redux/toolkit/vouchers/updateVoucher";
import { uplodImageAction } from "../../redux/toolkit/image/uplodImage";

const breadcrumb = (
    <Stack>
        <Breadcrumbs
            separator={
                <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
            }
            aria-label="breadcrumb"
        >
            <Link
                underline="hover"
                sx={{ color: "#5E6C8A" }}
                color="inherit"
                href="/"
            >
                Home
            </Link>

            <Link
                underline="hover"
                sx={{ color: "#5E6C8A" }}
                color="inherit"
                href="/allStoreVoucher"
            >
                All Vouchers
            </Link>

            <Link
                underline="hover"
                sx={{ color: "#5E6C8A" }}
                color="inherit"
                href="/editVoucher"
            >
                Edit Voucher
            </Link>
        </Breadcrumbs>
        <Typography sx={{ color: "#5E6C8A" }} variant="h5">
            Edit Voucher
        </Typography>
    </Stack>
);

const voucher_schema = yup
    .object()
    .shape({
        sku: yup.string().required("SKU is required"),
        name: yup.string().required("Voucher name is required"),
        // description: yup.string().required("Description is required"), // REMOVED
        // how_to_use_desc: yup.string().required("How to use description is required"), // REMOVED
        outer_color: yup.string(),
        // Price fields
        price_value: yup.string(),
        price_type: yup.string(),
        price_min: yup.string(),
        price_max: yup.string(),
        short_desc: yup.string(),
        // Image fields - validation removed (handled by upload)
    })
    .required();

const EditVoucher = () => {
    const dispatch = useDispatch();
    const [snack, setSnack] = useState(false);
    const [active, setIsActive] = useState(false);
    const navigate = useNavigate();
    const [howToUsePoints, setHowToUsePoints] = useState([]);
    const [denominations, setDenominations] = useState([]);
    const [newPoint, setNewPoint] = useState("");
    const [newDenomination, setNewDenomination] = useState("");

    // ⭐ ADDED: Separate state for JoditEditor fields
    const [description, setDescription] = useState("");
    const [howToUseDesc, setHowToUseDesc] = useState("");
    const [shortDescription, setShortDescription] = useState("")

    // ⭐ ADDED: State for image URLs
    const [imageMobile, setImageMobile] = useState("");
    const [imageThumbnail, setImageThumbnail] = useState("");
    const [imageBase, setImageBase] = useState("");
    const [imageSmall, setImageSmall] = useState("");

    const [searchParams] = useSearchParams();
    const { id } = useParams();

    const { updateVoucher: data, loading } = useSelector(
        (state) => state.updateSingleVoucher
    );

    const singleVoucherData = useSelector((state) => state.singleVoucher);
    const { data: singleVoucher } = singleVoucherData;

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        watch
    } = useForm({
        resolver: yupResolver(voucher_schema),
        defaultValues: {},
    });

    // Handle form submission
    // ⭐ UPDATED: Using state values for description, how_to_use_desc, and images
    const handleVoucherUpdate = async (data) => {
        let voucher_info = {
            voucher_id: id,
            sku: data?.sku,
            name: data?.name,
            price: {
                price: data?.price_value || "",
                type: data?.price_type || "",
                min: data?.price_min || "",
                max: data?.price_max || "",
                denominations: denominations,
            },
            how_to_use_desc: howToUseDesc, // ⭐ CHANGED: From state instead of data
            how_to_use_points: howToUsePoints,
            description: description, // ⭐ CHANGED: From state instead of data
            image: {
                thumbnail: imageThumbnail || "", // ⭐ CHANGED: From state
                mobile: imageMobile || "",       // ⭐ CHANGED: From state
                base: imageBase || "",           // ⭐ CHANGED: From state
                small: imageSmall || "",         // ⭐ CHANGED: From state
            },
            outer_color: data?.outer_color || "",
            is_active: active,
            short_desc: shortDescription
        };

        console.log("voucher_info====================>", voucher_info);

        // TODO: Implement API call in next task
        const updateVoucherData = await dispatch(
            updateVoucherAction(voucher_info)
        );
        setSnack(true);
        if (updateVoucherData?.payload?.status == 200) {
            reset();
            setTimeout(() => {
                navigate("/allStoreVoucher");
            }, 1500);
        }
    };

    const handleSwitchChange = () => {
        setIsActive(!active);
    };

    const handleClose = function () {
        reset();
        navigate("/allStoreVoucher");
    };

    // Add How to Use Point
    const handleAddPoint = () => {
        if (newPoint.trim()) {
            setHowToUsePoints([...howToUsePoints, newPoint]);
            setNewPoint("");
        }
    };

    // Remove How to Use Point
    const handleRemovePoint = (index) => {
        setHowToUsePoints(howToUsePoints.filter((_, i) => i !== index));
    };

    // Add Denomination
    const handleAddDenomination = () => {
        if (newDenomination.trim()) {
            setDenominations([...denominations, newDenomination]);
            setNewDenomination("");
        }
    };

    // Remove Denomination
    const handleRemoveDenomination = (index) => {
        setDenominations(denominations.filter((_, i) => i !== index));
    };

    // ⭐ ADDED: Image upload handlers for all 4 images
    const handleImageUpload = async (e, imageType) => {
        const formData = new FormData();
        const file = e.target.files[0];

        if (!file) return;

        formData.append("file", file);

        let FileSize = Number(file.size / 1000); // Size in KB

        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var width, height;

        img.onload = async function () {
            width = this.width;
            height = this.height;

            // Check file size (max 5MB = 5000KB)
            if (FileSize > 5000) {
                return alert(
                    `Image should be under 5MB. Your file size is ${FileSize.toFixed(2)}KB`
                );
            }
            try {
                // Upload image
                let uploadedImg = await dispatch(uplodImageAction(formData));
                const imgUrl = uploadedImg?.payload?.data?.url;

                if (imgUrl) {
                    // Set image URL based on type
                    switch (imageType) {
                        case "mobile":
                            setImageMobile(imgUrl);
                            setValue("image_mobile", imgUrl);
                            break;
                        case "thumbnail":
                            setImageThumbnail(imgUrl);
                            setValue("image_thumbnail", imgUrl);
                            break;
                        case "base":
                            setImageBase(imgUrl);
                            setValue("image_base", imgUrl);
                            break;
                        case "small":
                            setImageSmall(imgUrl);
                            setValue("image_small", imgUrl);
                            break;
                    }

                    alert(
                        `${imageType.charAt(0).toUpperCase() + imageType.slice(1)} image uploaded successfully! File size: ${FileSize.toFixed(2)}KB`
                    );
                } else {
                    alert("Image upload failed. Please try again.");
                }
            } catch (error) {
                console.error("Image upload error:", error);
                alert("Error uploading image. Please try again.");
            }
        };

        img.onerror = function () {
            alert("Not a valid image file: " + file.type);
        };

        img.src = _URL.createObjectURL(file);
    };

    // Individual handlers for each image type
    const handleMobileImage = (e) => handleImageUpload(e, "mobile");
    const handleThumbnailImage = (e) => handleImageUpload(e, "thumbnail");
    const handleBaseImage = (e) => handleImageUpload(e, "base");
    const handleSmallImage = (e) => handleImageUpload(e, "small");

    // Load voucher data when component mounts
    useEffect(() => {
        if (id) {
            // TODO: Dispatch action to get single voucher
            dispatch(getSingleVoucherAction({ voucher_id: id }));
        }
    }, [id]);

    // Populate form when voucher data is loaded
    // ⭐ UPDATED: Set JoditEditor states and image states separately
    useEffect(() => {
        if (singleVoucher) {
            // Reset form with voucher data (except description and image fields)
            reset({
                sku: singleVoucher?.sku || "",
                name: singleVoucher?.name || "",
                // description: singleVoucher?.description || "", // REMOVED
                // how_to_use_desc: singleVoucher?.how_to_use_desc || "", // REMOVED
                outer_color: singleVoucher?.outer_color || "",
                price_value: singleVoucher?.price?.price || "",
                price_type: singleVoucher?.price?.type || "",
                price_min: singleVoucher?.price?.min || "",
                price_max: singleVoucher?.price?.max || "",
                // image_mobile: singleVoucher?.image?.mobile || "", // REMOVED
                // image_thumbnail: singleVoucher?.image?.thumbnail || "", // REMOVED
                // image_base: singleVoucher?.image?.base || "", // REMOVED
                // image_small: singleVoucher?.image?.small || "", // REMOVED
            });

            // ⭐ ADDED: Set JoditEditor states separately
            setDescription(singleVoucher?.description || "");
            setHowToUseDesc(singleVoucher?.how_to_use_desc || "");
            setShortDescription(singleVoucher?.short_desc || "")

            // ⭐ ADDED: Set image states
            setImageMobile(singleVoucher?.image?.mobile || "");
            setImageThumbnail(singleVoucher?.image?.thumbnail || "");
            setImageBase(singleVoucher?.image?.base || "");
            setImageSmall(singleVoucher?.image?.small || "");

            setIsActive(singleVoucher?.is_active || false);
            setHowToUsePoints(singleVoucher?.how_to_use_points || []);
            setDenominations(singleVoucher?.price?.denominations || []);
        }
    }, [singleVoucher, reset]);

    return (
        <>
            <Helmet>
                <title>Edit Voucher</title>
            </Helmet>

            <Appbar breadcrumb={breadcrumb} title="Edit Voucher" />

            <Body>
                <Card sx={{ padding: 5 }}>
                    <Typography variant="h5" sx={{ mb: 5 }}>
                        Edit Voucher
                    </Typography>
                    <form onSubmit={handleSubmit(handleVoucherUpdate)}>
                        <Stack spacing={3}>
                            {/* SKU and Name */}
                            <Stack direction="row" spacing={10}>
                                <TextField
                                    label="SKU"
                                    error={!!errors?.sku}
                                    helperText={errors?.sku?.message}
                                    {...register("sku")}
                                    style={{ width: "450px" }}
                                    InputLabelProps={{ shrink: true }}

                                />
                            </Stack>

                            <Stack direction="row" spacing={10}>
                                <TextField
                                    label="Voucher Name"
                                    error={!!errors?.name}
                                    helperText={errors?.name?.message}
                                    {...register("name")}
                                    style={{ width: "450px" }}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Stack>

                            {/* ⭐ REPLACED: Description with JoditEditor */}
                            <Stack spacing={1}>
                                <Typography variant="subtitle1">Description</Typography>
                                <JoditEditor
                                    tabIndex={1}
                                    id="description"
                                    value={description}
                                    onBlur={(newContent) => {
                                        setDescription(newContent);
                                    }}
                                    onChange={(newContent) => {
                                        setDescription(newContent);
                                    }}
                                />
                            </Stack>

                            {/* ⭐ REPLACED: How to Use Description with JoditEditor */}
                            <Stack spacing={1}>
                                <Typography variant="subtitle1">How to Use Description</Typography>
                                <JoditEditor
                                    tabIndex={2}
                                    id="how_to_use_desc"
                                    value={howToUseDesc}
                                    onBlur={(newContent) => {
                                        setHowToUseDesc(newContent);
                                    }}
                                    onChange={(newContent) => {
                                        setHowToUseDesc(newContent);
                                    }}
                                />
                            </Stack>

                            <Stack spacing={1}>
                                <Typography variant="subtitle1">Short Description</Typography>
                                <JoditEditor
                                    tabIndex={2}
                                    id="short_description"
                                    value={shortDescription}
                                    onBlur={(newContent) => {
                                        setShortDescription(newContent);
                                    }}
                                    onChange={(newContent) => {
                                        setShortDescription(newContent);
                                    }}
                                />
                            </Stack>



                            {/* How to Use Points */}
                            <Stack spacing={2}>
                                <Typography variant="subtitle1">How to Use Points</Typography>
                                <Stack direction="row" spacing={2} sx={{display:"flex" , alignContent:"center"
                                }}>
                                    <TextField
                                        label="Add Point"
                                        value={newPoint}
                                        onChange={(e) => setNewPoint(e.target.value)}
                                        style={{ width: "380px" }}
                                        InputLabelProps={{ shrink: true }}
                                        onKeyPress={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                handleAddPoint();
                                            }
                                        }}
                                    />

                                    {/* <JoditEditor
                                        tabIndex={2}
                                        id="short_description"
                                        value={newPoint}
                                        onBlur={(newContent) => {
                                            setShortDescription(newContent);
                                        }}
                                        onChange={(newContent) => setNewPoint(newContent)}
                                        onKeyPress={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                handleAddPoint();
                                            }
                                        }}

                                    /> */}
                                    <Button
                                        variant="contained"
                                        sx={{height:"fit-content"}}
                                        startIcon={<AddIcon />}

                                        onClick={handleAddPoint}
                                    >
                                        Add
                                    </Button>
                                </Stack>
                                <Box>
                                    {howToUsePoints.map((point, index) => (
                                        <Chip
                                            key={index}
                                            label={point}
                                            onDelete={() => handleRemovePoint(index)}
                                            style={{ margin: "5px" }}
                                        />
                                    ))}
                                </Box>
                            </Stack>




                            {/* Price Section */}
                            <Typography variant="h6" sx={{ mt: 2 }}>
                                Price Information
                            </Typography>

                            <Stack direction="row" spacing={2}>
                                <TextField
                                    label="Price Value"
                                    {...register("price_value")}
                                    InputLabelProps={{ shrink: !!watch("Price Value") }}
                                    style={{ width: "215px" }}
                                />
                                <TextField
                                    label="Price Type"
                                    {...register("price_type")}
                                    InputLabelProps={{ shrink: !!watch("Price Type") }}
                                    style={{ width: "215px" }}
                                />
                            </Stack>

                            <Stack direction="row" spacing={2}>
                                <TextField
                                    label="Min Price"
                                    {...register("price_min")}
                                    style={{ width: "215px" }}
                                    InputLabelProps={{ shrink: !!watch("Min Price") }}

                                />
                                <TextField
                                    label="Max Price"
                                    {...register("price_max")}
                                    style={{ width: "215px" }}
                                />
                            </Stack>

                            {/* Denominations */}
                            <Stack spacing={2}>
                                <Typography variant="subtitle1">Denominations</Typography>
                                <Stack direction="row" spacing={2}>
                                    <TextField
                                        label="Add Denomination"
                                        value={newDenomination}
                                        onChange={(e) => setNewDenomination(e.target.value)}
                                        style={{ width: "380px" }}
                                        onKeyPress={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                handleAddDenomination();
                                            }
                                        }}
                                    />
                                    <Button
                                        variant="contained"
                                        startIcon={<AddIcon />}
                                        onClick={handleAddDenomination}
                                    >
                                        Add
                                    </Button>
                                </Stack>
                                <Box>
                                    {denominations.map((denomination, index) => (
                                        <Chip
                                            key={index}
                                            label={denomination}
                                            onDelete={() => handleRemoveDenomination(index)}
                                            style={{ margin: "5px" }}
                                        />
                                    ))}
                                </Box>
                            </Stack>

                            {/* Image URLs */}
                            <Typography variant="h6" sx={{ mt: 2 }}>
                                Image Upload
                            </Typography>

                            {/* Mobile Image */}
                            <Stack spacing={2}>
                                <Typography variant="subtitle2">Mobile Image</Typography>
                                <TextField
                                    type="file"
                                    accept="image/*"
                                    variant="outlined"
                                    id="mobile-image-upload"
                                    onChange={handleMobileImage}
                                    InputLabelProps={{ shrink: true }}
                                    style={{ width: "450px" }}
                                />
                                {imageMobile && (
                                    <Box>
                                        <Typography variant="caption" color="success.main">
                                            Current URL: {imageMobile}
                                        </Typography>
                                        <Box sx={{ mt: 1 }}>
                                            <img
                                                src={imageMobile}
                                                alt="Mobile preview"
                                                style={{ maxWidth: "200px", maxHeight: "200px", objectFit: "contain" }}
                                            />
                                        </Box>
                                    </Box>
                                )}
                            </Stack>

                            {/* Thumbnail Image */}
                            <Stack spacing={2}>
                                <Typography variant="subtitle2">Thumbnail Image</Typography>
                                <TextField
                                    type="file"
                                    accept="image/*"
                                    variant="outlined"
                                    id="thumbnail-image-upload"
                                    onChange={handleThumbnailImage}
                                    InputLabelProps={{ shrink: true }}
                                    style={{ width: "450px" }}
                                />
                                {imageThumbnail && (
                                    <Box>
                                        <Typography variant="caption" color="success.main">
                                            Current URL: {imageThumbnail}
                                        </Typography>
                                        <Box sx={{ mt: 1 }}>
                                            <img
                                                src={imageThumbnail}
                                                alt="Thumbnail preview"
                                                style={{ maxWidth: "200px", maxHeight: "200px", objectFit: "contain" }}
                                            />
                                        </Box>
                                    </Box>
                                )}
                            </Stack>

                            {/* Base Image */}
                            <Stack spacing={2}>
                                <Typography variant="subtitle2">Base Image</Typography>
                                <TextField
                                    type="file"
                                    accept="image/*"
                                    variant="outlined"
                                    id="base-image-upload"
                                    onChange={handleBaseImage}
                                    InputLabelProps={{ shrink: true }}
                                    style={{ width: "450px" }}
                                />
                                {imageBase && (
                                    <Box>
                                        <Typography variant="caption" color="success.main">
                                            Current URL: {imageBase}
                                        </Typography>
                                        <Box sx={{ mt: 1 }}>
                                            <img
                                                src={imageBase}
                                                alt="Base preview"
                                                style={{ maxWidth: "200px", maxHeight: "200px", objectFit: "contain" }}
                                            />
                                        </Box>
                                    </Box>
                                )}
                            </Stack>

                            {/* Small Image */}
                            <Stack spacing={2}>
                                <Typography variant="subtitle2">Small Image</Typography>
                                <TextField
                                    type="file"
                                    accept="image/*"
                                    variant="outlined"
                                    id="small-image-upload"
                                    onChange={handleSmallImage}
                                    InputLabelProps={{ shrink: true }}
                                    style={{ width: "450px" }}
                                />
                                {imageSmall && (
                                    <Box>
                                        <Typography variant="caption" color="success.main">
                                            Current URL: {imageSmall}
                                        </Typography>
                                        <Box sx={{ mt: 1 }}>
                                            <img
                                                src={imageSmall}
                                                alt="Small preview"
                                                style={{ maxWidth: "200px", maxHeight: "200px", objectFit: "contain" }}
                                            />
                                        </Box>
                                    </Box>
                                )}
                            </Stack>

                            {/* Outer Color */}
                            <Stack direction="row" spacing={10}>
                                <TextField
                                    label="Outer Color (Hex Code)"
                                    placeholder="#455354"
                                    error={!!errors?.outer_color}
                                    helperText={errors?.outer_color?.message}
                                    {...register("outer_color")}
                                    style={{ width: "450px" }}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Stack>

                            {/* Is Active Switch */}
                            <Stack direction="row" spacing={10}>
                                <FormControlLabel
                                    control={
                                        <Switch onChange={handleSwitchChange} checked={active} />
                                    }
                                    label="Is Active"
                                />
                            </Stack>

                            {/* Submit Buttons */}
                            <Stack direction="row" spacing={2}>
                                <Button variant="contained" type="submit" disabled={loading}>
                                    {loading ? <CircularProgress size={24} /> : "Update Voucher"}
                                </Button>
                                <Button variant="contained" color="error" onClick={handleClose}>
                                    Cancel
                                </Button>
                            </Stack>
                        </Stack>
                    </form>
                </Card>
            </Body>
        </>
    );
};

export default EditVoucher;